import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { validateRuleData } from '@/decorators';
import { enumData, loading } from '@/decorators';
import { yesNoStatus } from '@/enum';
import { getAllListBulkRequest } from '@/utils/bulkRequest';
import { namespace } from 'vuex-class';
var User = namespace('user');

var ModalForm = function (_super) {
  __extends(ModalForm, _super);

  function ModalForm() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.packageReqEnum = [];
    _this.packageSelectEnum = [];
    _this.skuWrapperSourceEnum = [];
    _this.loading = false;
    _this.packageisNeedEnum = yesNoStatus;
    _this.warehouseList = [];
    _this.productList = [];
    _this.formDataRule = {};
    _this.wrapperList = [];
    _this.detailsData = {};
    _this.formData = _this.initFormData();
    return _this;
  }

  Object.defineProperty(ModalForm.prototype, "isProductPrivateWrapper", {
    get: function get() {
      return this.customerInfo.is_product_private_wrapper;
    },
    enumerable: false,
    configurable: true
  });

  ModalForm.prototype.onWarehouseCodeChange = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!value) return [3, 2];
            _a = this;
            return [4, this.queryWarpperList()];

          case 1:
            _a.wrapperList = _b.sent();
            return [3, 3];

          case 2:
            this.wrapperList = [];
            _b.label = 3;

          case 3:
            return [2];
        }
      });
    });
  };

  Object.defineProperty(ModalForm.prototype, "wrapperOptionList", {
    get: function get() {
      var _a;

      var _this = this;

      if (this.$util.isEmpty(this.formData.warehouse_code)) {
        return [];
      }

      var packageTypeEnum = (_a = {}, _a[this.$enum.warehouse.WrapperPackageType.PUBLIC] = this.$enum.product.SkuWrapperSourceEnum.PUBLIC, _a[this.$enum.warehouse.WrapperPackageType.PRIVATE] = this.$enum.product.SkuWrapperSourceEnum.PRIVATE, _a);
      return this.wrapperList.filter(function (item) {
        return (item.package_code.indexOf(_this.formData.package_code || '') > -1 || !_this.formData.package_code) && (String(_this.formData.package_req) === String(item.package_category) || _this.$util.isEmpty(_this.formData.package_req)) && _this.formData.sku_wrapper_source === packageTypeEnum[item.package_type];
      }).slice(0, 200);
    },
    enumerable: false,
    configurable: true
  });

  ModalForm.prototype.initFormData = function (data) {
    var originData = {
      id: undefined,
      product_sku: '',
      warehouse_code: undefined,
      need_package: undefined,
      package_select: undefined,
      package_req: undefined,
      package_code: '',
      sku_wrapper_type: undefined,
      sku_wrapper_source: undefined
    };

    if (!data) {
      return originData;
    }

    for (var key in originData) {
      if (data.hasOwnProperty(key)) {
        originData[key] = data[key];
      }
    }

    return originData;
  };

  ModalForm.prototype.getConfirmRuleData = function (data) {
    var rules = {
      product_sku: [{
        required: true,
        message: this.t('请输入商品编码')
      }, {
        pattern: /^\S+$/,
        message: this.t('商品编码不支持输入空格')
      }],
      warehouse_code: [{
        required: true,
        message: this.t('请选择适用仓库（区域）')
      }],
      need_package: [{
        required: true,
        message: this.t('请选择是否需要包材')
      }],
      package_select: [{
        required: true,
        message: this.t('请选择包装选择方')
      }],
      sku_wrapper_source: [{
        required: true,
        message: this.t('请选择包装归属')
      }],
      package_req: [{
        required: true,
        message: this.t('请选择包材要求')
      }]
    };
    this.formDataRule = this.$util.mergeValidate(data, rules);
  };

  ModalForm.prototype.queryDetail = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.queryProductWrapperDetails({
              id: this.rowData.data.id
            })];

          case 1:
            data = _a.sent().data;
            this.detailsData = data || {};
            this.formData = this.initFormData(this.detailsData);
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.getSizeText = function (detailsData) {
    if (Object.keys(detailsData).length) {
      return detailsData.declare_length + "*" + detailsData.declare_width + "*" + detailsData.declare_height;
    } else {
      return '';
    }
  };

  ModalForm.prototype.queryProductList = function (productSku) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.queryProductList({
              page_index: 1,
              page_size: 100,
              product_sku_list: [productSku],
              product_status: this.$enum.product.ProductStatusEnum.AVAILABLE,
              is_select_flag: true
            }, {
              loading: false
            })];

          case 1:
            data = _a.sent().data;
            this.productList = data.list;
            return [2, data.list || []];
        }
      });
    });
  };

  ModalForm.prototype.queryWarpperList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, getAllListBulkRequest(function (param) {
              return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4, this.$api.wrapper.queryWrapperList(param)];

                    case 1:
                      data = _a.sent().data;
                      return [2, data.list];
                  }
                });
              });
            }, {
              warehouse_code: this.formData.warehouse_code,
              status: this.$enum.warehouse.WrapperStatus.PASS,
              page_size: 200,
              page_index: 1
            })];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  ModalForm.prototype.editProductWrapper = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.editProductWrapper(param)];

          case 1:
            _a.sent();

            this.$message.success(this.t('保存成功'));
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.addProductWrapper = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.wrapper.addProductWrapper(param)];

          case 1:
            _a.sent();

            this.$message.success(this.t('新增成功'));
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.handleCheckSelectedProductSku = function (sku) {
    if (this.detailsData.product_sku !== sku) {
      this.detailsData = {};
    }
  };

  ModalForm.prototype.handleSelectProductSku = function () {
    var item = this.$util.findItemByKeyValue(this.productList, this.formData.product_sku, 'product_sku');

    if (item) {
      this.detailsData = {
        product_sku: item.product_sku,
        product_name_cn: item.product_name_cn,
        declare_length: String(item.product_length),
        declare_width: String(item.product_width),
        declare_height: String(item.product_height),
        declare_weight: String(item.product_weight),
        sku_wrapper_type: item.sku_wrapper_type,
        sku_wrapper_type_text: item.sku_wrapper_type_text
      };
      this.formData.sku_wrapper_type = item.sku_wrapper_type;

      if (this.detailsData.sku_wrapper_type === this.$enum.product.ProductSkuWrapperTypeEnum.SALES_WRAPPER) {
        this.$set(this.formData, 'need_package', this.$enum.common.Enabled.YES);
      }
    } else {
      this.detailsData = {};
      this.formData.sku_wrapper_type = undefined;
    }
  };

  ModalForm.prototype.handleWhCodeChange = function () {
    this.formData.package_code = '';
  };

  ModalForm.prototype.handlePackageCodeChange = function (packageCode) {
    var _this = this;

    var wrapper = this.wrapperList.find(function (item) {
      return item.package_code === _this.formData.package_code;
    });

    if (packageCode && wrapper && this.$util.isEmpty(this.formData.package_req)) {
      this.formData.package_req = Number(wrapper.package_category);
      var formDataRef = this.$refs.formDataRef;
      formDataRef.validateField('package_req', function () {});
    }
  };

  ModalForm.prototype.handlePackageReqChange = function () {
    this.formData.package_code = '';
  };

  ModalForm.prototype.handleNeedPackage = function () {
    this.formData.package_select = undefined;
    this.formData.package_req = undefined;
    this.formData.package_code = '';
    this.formData.sku_wrapper_source = undefined;
  };

  ModalForm.prototype.handlePackageSelect = function () {
    this.formData.package_req = undefined;
    this.formData.package_code = '';
  };

  ModalForm.prototype.handleSkuWrapperSourceChange = function () {
    this.formData.package_code = '';
  };

  ModalForm.prototype.handleSearchSkuList = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.queryProductList(value)];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  ModalForm.prototype.handleSave = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formDataRef = this.$refs.formDataRef;
            return [4, formDataRef.validate()];

          case 1:
            res = _a.sent();

            if (!res) {
              return [2];
            }

            if (!this.formData.id) return [3, 3];
            return [4, this.editProductWrapper(this.formData)];

          case 2:
            _a.sent();

            return [3, 5];

          case 3:
            return [4, this.addProductWrapper(this.formData)];

          case 4:
            _a.sent();

            _a.label = 5;

          case 5:
            this.$emit('success');
            this.$emit('update:visible', false);
            return [2];
        }
      });
    });
  };

  ModalForm.prototype.handleClose = function () {
    this.$emit('update:visible', false);
  };

  ModalForm.prototype.handleVisibleChange = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formDataRef;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.visible) return [3, 3];
            this.detailsData = {};
            this.formData = this.initFormData(this.rowData.data);
            if (!(this.rowData && this.rowData.data)) return [3, 2];
            return [4, this.queryDetail()];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            return [3, 4];

          case 3:
            formDataRef = this.$refs.formDataRef;
            formDataRef && formDataRef.clearValidate();
            _a.label = 4;

          case 4:
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], ModalForm.prototype, "visible", void 0);

  __decorate([Prop({})], ModalForm.prototype, "rowData", void 0);

  __decorate([enumData('Wrapper/PackageReqEnum')], ModalForm.prototype, "packageReqEnum", void 0);

  __decorate([enumData('Wrapper/PackageSelectEnum')], ModalForm.prototype, "packageSelectEnum", void 0);

  __decorate([enumData('Wrapper/SkuWrapperSourceEnum')], ModalForm.prototype, "skuWrapperSourceEnum", void 0);

  __decorate([User.State('customerInfo')], ModalForm.prototype, "customerInfo", void 0);

  __decorate([Watch('formData.warehouse_code', {
    immediate: true
  })], ModalForm.prototype, "onWarehouseCodeChange", null);

  __decorate([validateRuleData('/api/v1/commodity_importer/add')], ModalForm.prototype, "getConfirmRuleData", null);

  __decorate([loading('loading')], ModalForm.prototype, "editProductWrapper", null);

  __decorate([loading('loading')], ModalForm.prototype, "addProductWrapper", null);

  __decorate([Watch('visible', {
    deep: true,
    immediate: true
  })], ModalForm.prototype, "handleVisibleChange", null);

  ModalForm = __decorate([Component], ModalForm);
  return ModalForm;
}(Vue);

export default ModalForm;